import { IChangeable } from './types';
import { INotificationOnlyModeSetting } from '../models/User';
import { makeAutoObservable } from 'mobx';

class NotificationOnlyModeSettingsStore implements IChangeable<INotificationOnlyModeSetting> {
	private _model: INotificationOnlyModeSetting = {} as INotificationOnlyModeSetting;
	private _changes: Partial<INotificationOnlyModeSetting> = {};

	constructor(model: INotificationOnlyModeSetting) {
		makeAutoObservable(this, {}, {autoBind: true});
		this._setModel(model);
	}

	private _setModel(model: INotificationOnlyModeSetting) {
		if (model) {
			this._model = this._ensureValidModel(model);
		}
		this.discardChanges();
	}

	public get isActive(): boolean { return this._changes.is_active ?? this._model.is_active; }
	public get refundToPaymentMethod(): boolean { return this._changes.refund_to_payment_method ?? this._model.refund_to_payment_method; }
	public get refundToStoreCredit(): boolean { return this._changes.refund_to_store_credit ?? this._model.refund_to_store_credit; }
	public get refundToGiftCard(): boolean { return this._changes.refund_to_gift_card ?? this._model.refund_to_gift_card; }

	setIsActive(value: boolean) {
		this._changes.is_active = value;
		this._clearUnneededChanges();
	}
	setRefundToPaymentMethod(value: boolean) {
		this._changes.refund_to_payment_method = value;
		this._clearUnneededChanges();
	}
	setRefundToStoreCredit(value: boolean) {
		this._changes.refund_to_store_credit = value;
		this._clearUnneededChanges();
	}
	setRefundToGiftCard(value: boolean) {
		this._changes.refund_to_gift_card = value;
		this._clearUnneededChanges();
	}

	public discardChanges(): void {
		this._changes = {};
	}

	public hasChanges() {
		return !!Object.keys(this._changes).length;
	}

	public getUpdatedModel(): INotificationOnlyModeSetting {
		return { ...this._model, ...this._changes, _has_changes: this.hasChanges() };
	}

	private _clearUnneededChanges() {
		Object.keys(this._changes).forEach(key => {
			const theKey = key as keyof INotificationOnlyModeSetting;
			if (this._changes[theKey] === this._model?.[theKey]) {
				delete this._changes[theKey];
			}
		});
	}

	private _ensureValidModel(model: INotificationOnlyModeSetting) {
		return {
			...model,
			is_active: Boolean(model.is_active),
			refund_to_payment_method: Boolean(model.refund_to_payment_method),
			refund_to_store_credit: Boolean(model.refund_to_store_credit),
			refund_to_gift_card: Boolean(model.refund_to_gift_card),
		}
	}
}

export default NotificationOnlyModeSettingsStore;
